(function() {
    'use strict';
    
    /**
     * Render the category menu for the desktop left layout
     * @name categoryMenuCtrl
     * @type ItxCategoryMenuCmpCtrl
     */
    var CategoryMenuCmp = {
        bindings: {
            category: '<',
            realCategoryHeracles: '<',
            onSectionLoaded: '&'
        },
        controller: CategoryMenuCmpCtrl,
        templateUrl: 'category-menu.component.html'
    };

    angular.module('itxApp.catalog').component('categoryMenu', CategoryMenuCmp);

    CategoryMenuCmpCtrl.$inject = [
        'categoryTreeSvc', 
        'menuToHtml', 
        'ItxHeaderFct', 
        'logger', 
        'CmsConfigSvc', 
        'attachmentManagerSvc',
        'ItxConfigurationSvc',
        '$rootScope'
    ];

    function CategoryMenuCmpCtrl(
        categoryTreeSvc, 
        menuToHtml, 
        ItxHeaderFct, 
        logger, 
        CmsConfigSvc, 
        attachmentManagerSvc,
        ItxConfigurationSvc,
        $rootScope
    ) {
        var _this = this;
        
        _this.$onInit = function(){
            initAttachment();
        };

        function initAttachment() {
            CmsConfigSvc.getProperty('category_attachments').then(function(data) {

                attachmentManagerSvc.initializeServiceValues(data).then(function() {
                    categoryTreeSvc.setFlagAttachment(true);
                    _this.getCategoryTree();
                }).catch(function() {
                    categoryTreeSvc.setFlagAttachment(false);
                    _this.getCategoryTree();
                });
            }).catch(function(){
                _this.getCategoryTree();
            });
        }


        _this.getCategoryTree = function(){

            var subMenuCategory = document.getElementById('js-ma-category-list');

            // POLIFYLL -append- IE 9 e inferiores 
            if (subMenuCategory.hasOwnProperty('append')) {
                return;
            }
            else{
                Object.defineProperty(subMenuCategory, 'append', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function append() {
                        var argArr = Array.prototype.slice.call(arguments),
                            docFrag = document.createDocumentFragment();
        
                        argArr.forEach(function(argItem) {
                            var isNode = argItem instanceof Node;
                            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                        });
        
                        this.appendChild(docFrag);
                    }
                });
            }
            
            // validamos si es la categoria heracles o no.

            var categoryId = null;
            if(_this.realCategoryHeracles !== null) {
              categoryId = _this.realCategoryHeracles.id;
            } else {
              categoryId = inditex.iCategoryId;
            }


            categoryTreeSvc.getFamilyCategoryId( categoryId )
            .then(function (objFamilyId) {

                ItxHeaderFct.setLastSection(objFamilyId.section.id.toUpperCase());
                _this.section = objFamilyId.section.name;
                var getMenuLevel2 = true;
                _this.onSectionLoaded();
                menuToHtml.getList( objFamilyId.categories[ objFamilyId.section.id ], getMenuLevel2 , 'sidebar').then(function (arrayColumns) {
                    for (var i = 0; i < arrayColumns.length; i++) {
                        subMenuCategory.append( arrayColumns[i] );
                    }
                    menuToHtml.addEvents('#js-ma-category-list');
                    _this.openTabCurrentCategory(objFamilyId);

                    if(ItxConfigurationSvc.isDebugActive() && ItxConfigurationSvc.getDebugOptions().showCategoryIds) {
                        _printMenuDebug();
                    }

                    menuToHtml.setStickySideMenu();
                });

            }).catch(function(reason) {
                logger.logError(reason);
            });
        };

        function _printMenuDebug(section) {
            
            var liEls = $("#js-ma-category-list").find('li');;
             var aEls = $("#js-ma-category-list").find('a');

            // Menú lateral
            $(liEls).each(function(){
                var dataId = $(this).attr('data-id');
                if(dataId) {
                    var spanEl = $(this).children('span');
                    if(spanEl) {
                        var textSpan =  $(spanEl).text() + ' ' + dataId;
                        $(spanEl).text(textSpan); 
                    }
                }
            });

            $(aEls).each(function() {
                var dataId = $(this).attr('data-id');
                if(dataId) {
                    var textA = $(this).text() + ' ' + dataId;
                    $(this).text(textA); 
                }
            });
        }

        _this.$onChanges = function(){
            _this.addActiveCurrentCategory();
        };

        _this.openTabCurrentCategory = function(objFamilyId) {
            logger.log('openTabCurrentCategory ', objFamilyId);            

            if(objFamilyId.grandmotherCategory){ 
                $('[data-id='+ objFamilyId.grandmotherCategory.id +']').children().show();
                $('[data-id='+ objFamilyId.grandmotherCategory.id +']').addClass('ma-open-menu');
            }
            if(objFamilyId.parentCategory){ 
                $('[data-id='+ objFamilyId.parentCategory.id +']').children().show();
                $('[data-id='+ objFamilyId.parentCategory.id +']').addClass('ma-open-menu');
            }
            if(objFamilyId.category){ 
                $('[data-id='+ objFamilyId.category.id +']').addClass('active');
            }

        };

        _this.addActiveCurrentCategory = function() {

            if(_this.realCategoryHeracles !== null) {
              logger.log('addActiveCurrentCategory ', _this.realCategoryHeracles);            
              $('.ma-category-link').removeClass('active');
              $('[data-id='+ _this.realCategoryHeracles.id +']').addClass('active');
            } else {
              logger.log('addActiveCurrentCategory ', _this.category);            
              $('.ma-category-link').removeClass('active');
              $('[data-id='+ _this.category.id +']').addClass('active');
            }
        };

    }
    
})();